module.exports = __webpack_public_path__ + "static/media/thumbnail.71cbe11e.jpg";